import { Sparkles, ShieldCheck, Globe2 } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionShell } from "./Reveal";

export default function Mission() {
  const { t } = useLang();
  const paragraphs = t.mission.lines;

  return (
    <SectionShell id="mission" testid="mission-section" className="overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-40">
        <img
          src="https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F8FAFC] via-[#F8FAFC]/70 to-[#F8FAFC]" />
      </div>

      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            {t.mission.title}
          </h2>
        </Reveal>

        <Reveal delay={0.12} className="mt-8 space-y-6 text-slate-600 leading-relaxed text-base sm:text-lg">
          {paragraphs.map((p, i) => (
            <p key={i} className={i === 0 ? "text-lg sm:text-xl font-semibold text-slate-800" : ""}>
              {p}
            </p>
          ))}
          <p className="pt-2 font-display text-lg sm:text-xl font-bold text-sky-700">{t.mission.closing}</p>
        </Reveal>
      </div>
    </SectionShell>
  );
}
